import { render, staticRenderFns } from "./ClassicPay.vue?vue&type=template&id=e5ecc3d4&"
import script from "./ClassicPay.vue?vue&type=script&lang=ts&"
export * from "./ClassicPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports